import { constants } from "redux/constants/redux-constants";

// Add a new active SOAP generation (patientId, encounterId, optional observationId)
export const addActiveSOAPGeneration = (payload) => ({
  type: constants.ACTIVE_SOAP_GENERATION.ADD_ACTIVE_SOAP_GENERATION,
  payload, // { patientId, encounterId, observationId }
});

// Remove an active SOAP generation (by patientId and encounterId)
export const removeActiveSOAPGeneration = (payload) => ({
  type: constants.ACTIVE_SOAP_GENERATION.REMOVE_ACTIVE_SOAP_GENERATION,
  payload, // { patientId, encounterId }
});

// Set whether to show the floating progress bar widget
export const setShowProgressBar = (show) => ({
  type: constants.ACTIVE_SOAP_GENERATION.SET_SHOW_PROGRESS_BAR,
  payload: show,
});

// Clear all active SOAP generations (useful on logout or reset)
export const clearAllActiveSOAPGenerations = () => ({
  type: constants.ACTIVE_SOAP_GENERATION.CLEAR_ALL_ACTIVE_SOAP_GENERATIONS,
});

// Optionally, add actions for refreshing patient history if you use that pattern
export const refreshPatientHistory = (payload) => ({
  type: constants.ACTIVE_SOAP_GENERATION.REFRESH_PATIENT_HISTORY,
  payload, // { patientId, encounterId }
});

export const clearRefreshPatientHistory = (payload) => ({
  type: constants.ACTIVE_SOAP_GENERATION.CLEAR_REFRESH_PATIENT_HISTORY,
  payload, // { patientId, encounterId }
});